import styled from 'styled-components';

export const FooterContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PreGenerationOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;